import englishMessages from '@financialharmony/i18n/en';
import { createI18nAlerts, createI18nHandlers, type I18nAlert } from '@financialharmony/i18n/alerts';
import { Sentry } from '@/lib/sentry';

/** One named `errorType` alert per cause per page session, carrying `trackingIssue` (edge-case-triage). */
function reportToSentry(alert: I18nAlert): void {
  Sentry.captureMessage(`${alert.errorType}: ${alert.detail}`, {
    level: 'warning',
    tags: { errorType: alert.errorType, trackingIssue: alert.trackingIssue, locale: alert.locale },
  });
}

export const i18nAlerts = createI18nAlerts(reportToSentry);

// The language on screen, kept by LocaleProvider (`setActiveCatalog`); English until it has loaded one.
let activeLocale = 'en';

export function setAlertLocale(locale: string): void {
  activeLocale = locale;
}

/** `onError` / `getMessageFallback` for every `IntlProvider` and `createTranslator` in this app. */
export const i18nHandlers = createI18nHandlers(i18nAlerts, englishMessages, () => activeLocale);
